module.exports = __webpack_public_path__ + "img/referal.d5fd7aa7.png";